import Modal from '../Settings/Modal';
import { SettingModal, useSettingModal } from '../../../hooks/Context';
import styled from '@emotion/styled';
import styles from './css/display-applicant.module.css';
import { TopDisplay} from '../../../ui-components';

import DisplayOldApplicants from './DisplayOldApplicants';
// import { UploadBtn } from '../Applicants/Applicants';



interface OldApplicants {
  Id: number;
  IsNewApplicant: boolean;
  Name: string;
  PreviousEmail: string;
  PhoneNumber: string;
  ApplicationType: string;
  Status: string;
}

export default function OldApplicants(){

  return (

    <SettingModal>
        <ViewWrapper>
            <TopDisplay subTitle="All" title="OldApplicants" btnText="Download Old-Applicant" showBtn={true}/>
            <DisplayOldApplicants />
        </ViewWrapper>
        <Modal />
  </SettingModal>
  )}
  

const ViewWrapper = styled.div`
    padding:0 48px 48px;
    width:100%;
    flex-direction:column;
`
